import React from 'react';
import { Tooltip, useTheme } from '@mui/material';
import TransactionButton from '@shared/components/TransactionButton';

export const BookButton = ({
  canBuy,
  tooltipText,
  handleClick,
  disabled,
  color,
  backgroundColor,
  label,
  businessTypes,
  variant = 'buy',
  size = 'medium',
}) => {
  const theme = useTheme();

  let tooltipContent = '';
  if (!canBuy && tooltipText) {
    if (businessTypes?.code === 'BTC') {
      tooltipContent = `En este momento no es posible realizar la ${tooltipText}. Dirigite a tu sucursal más cercana`;
    } else {
      tooltipContent = `En este momento no es posible realizar la ${tooltipText}. Comunicate con tu vendedor de confianza`;
    }
  }

  // Botón
  const button = (
    <TransactionButton
      variant={variant}
      disabled={disabled}
      onClick={handleClick}
      size={size}
      boxSx={{ color, backgroundColor }}
    >
      {label}
    </TransactionButton>
  );

  if (tooltipContent) {
    return (
      <Tooltip
        title={tooltipContent}
        arrow
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: '#ffff',
              color: theme.text2 || '#000',
              border: `2px solid ${theme.darkGray || '#ccc'}`,
              textAlign: 'center',
              fontSize: 14,
              padding: '5px 10px',
              margin: '0px',
            },
          },
        }}
      >
        <div style={{ width: '100%' }}>{button}</div>
      </Tooltip>
    );
  }

  return button;
};
